import React, { useState } from 'react';


const FeatureCard = ({title,image}) => {
    const [isHovered, setIsHovered] = useState(false);
    const handleMouseEnter = () => {
      setIsHovered(true);
    };
  
    const handleMouseLeave = () => {
      setIsHovered(false);
    };
  return (
    <div
          className={`flex flex-col items-center lg:w-[300px] lg:h-[300px] w-[100px] h-[100px]  rounded-2xl border select-none border-[#0C2D57] cursor-pointer  justify-center p-10 transition-all duration-300  ${
            isHovered ? 'scale-105 bg-[#0C2D57]  ' : 'bg-slate-300'
          }`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <img draggable="false"   src={image} alt="feature" className='lg:w-1/3 p-2 mt-2 w-20 bg-white rounded hidden lg:block' />
          <p className={`transition-all duration-300  ${ isHovered ? '  text-white' : 'text-[#0C2D57] '} text-center text-[10px] lg:text-lg font-bold py-5`}>{title}</p>
          
        </div>
  )
}

export default FeatureCard